module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n\n")
    ;  if (cookingTask.swhid.match(/^swh:1:dir:.*/)) { 
    ; __append("\n  <tr id=\"vault-task-")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("\" title=\"Once downloaded, the directory can be extracted with the following command:\n\n$ tar xvzf ")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append(".tar.gz\">\n")
    ;  } else { 
    ; __append("\n  </tr><tr id=\"vault-task-")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("\" title=\"Once downloaded, the git repository can be imported to a 'new_repository' directory with the following commands:\n\n$ tar xvf ")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append(".git.tar\n$ git clone ")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append(".git new_repository\n$ cd new_repository/\">\n")
    ;  } 
    ; __append("\n    <td>\n      <div class=\"custom-control custom-checkbox\">\n      <input type=\"checkbox\" class=\"custom-control-input vault-task-toggle-selection\" id=\"vault-task-toggle-selection-")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("\">\n      <label class=\"custom-control-label\" for=\"vault-task-toggle-selection-")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("\">\n      </label>\n    </div></td>\n    ")
    ;  if (cookingTask.origin) { 
    ; __append("\n      <td class=\"vault-origin\">\n        <a href=\"")
    ; __append(escapeFn( Urls.browse_origin() ))
    ; __append("?origin_url=")
    ; __append(escapeFn( cookingTask.origin ))
    ; __append("\">\n          ")
    ; __append(escapeFn( decodeURIComponent(cookingTask.origin) ))
    ; __append("\n        </a>\n      </td>\n    ")
    ;  } else { 
    ; __append("\n      <td class=\"vault-origin\">unknown</td>\n    ")
    ;  } 
    ; __append("\n    <td>\n      <i class=\"")
    ; __append(escapeFn( swh.webapp.getSwhObjectIcon(cookingTask.swhid.match(/swh:1:([a-z]+):/)[1]) ))
    ; __append(" mdi-fw\"></i>\n      ")
    ; __append(escapeFn( cookingTask.bundle_type ))
    ; __append("\n    </td>\n    <td class=\"vault-object-info\" data-swhid=\"")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("\">\n      <b>id:</b>&nbsp;<a href=\"")
    ; __append(escapeFn( browseUrl ))
    ; __append("\">")
    ; __append(escapeFn( cookingTask.swhid ))
    ; __append("</a>\n      ")
    ;  if (cookingTask.path) { 
    ; __append("\n        <br><b>path:</b>&nbsp;")
    ; __append(escapeFn( cookingTask.path ))
    ; __append("\n      ")
    ;  } 
    ; __append("\n    </td>\n    <td>")
    ; __append( progressBar.outerHTML )
    ; __append("</td>\n    <td class=\"vault-dl-link\">\n      ")
    ;  if (cookingTask.status === 'done') { 
    ; __append("\n        <button class=\"btn btn-default btn-sm\" onclick=\"swh.vault.fetchCookedObject('")
    ; __append(escapeFn( cookingTask.fetch_url ))
    ; __append("')\">\n          <i class=\"mdi mdi-download mdi-fw\" aria-hidden=\"true\"></i>Download\n        </button>\n      ")
    ;  } 
    ; __append("\n    </td>\n  </tr>\n")
  }
  return __output;

}